import classNames from 'classnames';

interface HorizontalProgressBarProps {
  progress?: number;
  customClass?: string;
  showProgress?: boolean;
  ariaLabel?: string;
}

const HorizontalProgressBar = ({
  progress = 0,
  customClass = '',
  showProgress = true,
  ariaLabel = 'Course progress',
}: HorizontalProgressBarProps): React.JSX.Element => (
  <div
    role="progressbar"
    aria-valuenow={progress}
    aria-valuemin={0}
    aria-valuemax={100}
    aria-label={ariaLabel}
    className={`w-full bg-navy-400 rounded-full ${customClass}`}
  >
    <div
      className={classNames('p-0.5 leading-none rounded-md', {
        'bg-navy-800': showProgress,
      })}
      style={{ width: `${progress}%` }}
    ></div>
  </div>
);

export default HorizontalProgressBar;
